import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    footer: {
      save: translate({ id: 'form.drivers.edit.footer.save' }),
      create: translate({ id: 'form.drivers.edit.footer.create' }),
      cancel: translate({ id: 'form.drivers.edit.footer.cancel' }),
    },
    header: {
      newDriver: translate({ id: 'form.drivers.edit.header.newDriver' }),
    },
    form: {
      driverAppTitle: translate({ id: 'form.drivers.driverApp.title' }),
    },
    gpsDeviceIdOptions: {
      otherAccount: translate({ id: 'form.drivers.edit.gpsDeviceId.otherAccount' }),
    },
  }))

  return api
}
